import script from "./me.vue?vue&type=script&setup=true&lang=ts"
export * from "./me.vue?vue&type=script&setup=true&lang=ts"

import "./me.vue?vue&type=style&index=0&id=d3edc3ce&scoped=true&lang=less"

import exportComponent from "/Users/n0ts/Projects/IceCreamSearch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3edc3ce"]])

export default __exports__